import React from 'react';
import {Route, Switch} from "react-router-dom";
import BillingStatusRoute from "./BillingStatusRoute";

const BillingStatusRoutes = () => {
    return (
        <Switch>
            <Route exact path="/billing/status" component={BillingStatusRoute}/>
        </Switch>
    );
};

export default BillingStatusRoutes;
